import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top whenever the route changes.
 * Place this once inside <BrowserRouter> so every page navigation
 * starts at the top of the viewport.
 *
 * Hash fragments (#section) are honored - we don't override
 * intentional in-page anchor scrolls.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let browser handle anchor scroll
    // Use 'instant' so users don't watch a long smooth scroll on every nav
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
